<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M17.751 3h3.067l-6.7 7.658L22 21.078h-6.172l-4.833-6.32-5.531 6.32h-3.07l7.167-8.19L2 3h6.328l4.37 5.777L17.75 3Zm-1.076 16.242h1.7L7.404 4.74H5.58l11.094 14.503Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
